<div class="row">
  <div *ngIf="versionInfo.version && versionInfo.updateDate" class="col-md-12 float-left">
    Current SESTEK Portal Version : {{ versionInfo.version }} ({{ versionInfo.updateDate }})
  </div>
  <div class="col-md-12 float-left">
    Current SESTEK Portal UI Version : {{ versionInfo.uiVersion }} ({{ versionInfo.uiUpdateDate }})
  </div>
</div>
